import React from 'react';
import Badge from 'react-bootstrap/Badge';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { uiHelpers } from '../../helpers';
import { useUser } from '../../hooks/users';

const Style = styled.span`
  font-size: 0.8rem;

  & .bg-light {
    color: #555;
  }
`;

const PriceTimeBadge: React.FC<{ ts?: number }> = ({ ts }) => {
  const { i18n, t } = useTranslation();
  const user = useUser();
  const isAdmin = user && user.isAdmin;

  return (
    <Style>
      {ts ? (
        <OverlayTrigger
          trigger={['click', 'hover']}
          placement={isAdmin ? 'bottom' : 'top'}
          overlay={
            <Tooltip id="price-time-badge-explain">
              {uiHelpers.formatDateTimeLocalFromTimestamp(ts)}
            </Tooltip>
          }
        >
          <Badge bg="light" pill>
            {uiHelpers.formatDeltaDateTime(i18n, new Date(ts * 1000))}
          </Badge>
        </OverlayTrigger>
      ) : (
        <Badge bg="light" pill>
          {t('close')}
        </Badge>
      )}
    </Style>
  );
};

export default PriceTimeBadge;
